import {Box, Button} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";
import colors from "../../assets/theme/base/colors";

export const Pagination = ({handlePrevPage, handleNextPage, paginationUrls}) => {
  const {white, gradients} = colors;

  return (
    <Box display="flex" justifyContent="end" mt={2}>
      <Button
        variant="contained"
        startIcon={<ArrowBackIcon/>}
        onClick={handlePrevPage}
        disabled={!paginationUrls?.prev}
        sx={{
          width: "140px",
          border: "none",
          height: "38px",
          fontSize: "14px",
          color: white.main,
          marginRight: "5px",
          borderRadius: "6px",
          background: `${gradients.info.main}`,
          "&:hover": {
            background: `${gradients.info.state} !important`,
            color: white.main,
          },
        }}
      >
        Previous
      </Button>
      <Button
        variant="contained"
        endIcon={<ArrowForwardIcon/>}
        onClick={handleNextPage}
        disabled={!paginationUrls?.next}
        sx={{
          width: "140px",
          height: "38px",
          border: "none",
          fontSize: "14px",
          color: white.main,
          borderRadius: "6px",
          background: `${gradients.info.main}`,
          "&:hover": {
            background: `${gradients.info.state} !important`,
            color: white.main,
          },
        }}
      >
        Next
      </Button>
    </Box>
  );
}